import * as Yup from 'yup';

import { MAX_FILE_SIZE_10MB, PHONE_REGEX } from '@/common/constants';

const ALLOWED_CHARACTERS_REGEX = /^[a-zA-Z0-9\s.,/-]*$/;

export const shipOperatorNominationReviewSchema = (selectedStatus: string, selectedInvoiceCompany: string) => {
    return (
        Yup.object({
            invoiceCompanyName: (selectedStatus === '1' && !selectedInvoiceCompany) ? Yup.string()
                .trim()
                .required('Company name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters') : Yup.string().nullable(),
            invoiceCompanyAddress: (selectedStatus === '1' && !selectedInvoiceCompany) ? Yup.string()
                .trim()
                .required('Company address is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, slashes, and dashes.')
                .max(255, 'Max length is 255 characters') : Yup.string().nullable(),
            invoiceCompanyEmail: (selectedStatus === '1' && !selectedInvoiceCompany) ? Yup.string()
                .trim()
                .email('Enter a valid email address')
                .required('Company email address is required') : Yup.string().nullable(),
            invoiceCompanyPICName: (selectedStatus === '1' && !selectedInvoiceCompany) ? Yup.string()
                .trim()
                .required('Invoice company PIC name is required') : Yup.string().nullable(),
            invoiceCompanyPICMobile: (selectedStatus === '1' && !selectedInvoiceCompany) ? Yup.string()
                .trim()
                .required('Invoice company PIC mobile phone is required')
                .matches(PHONE_REGEX, 'Invoice company PIC mobile phone must contain only digits or a "+" sign')
                .max(15, 'Max length is 15 characters') : Yup.string().nullable(),
            shipOperatorStatusNotes: selectedStatus === '2' ? Yup.string()
                .trim()
                .required('Note is required') : Yup.string().nullable(),
            taxFileId: Yup.mixed()
                .nullable()
                .test('fileSize', 'File size is too large', (value) => {
                    if (value && (value as File).size > MAX_FILE_SIZE_10MB) {
                        return false;
                    }
                    return true;
                })
        }))
};
